import { render, staticRenderFns } from "./ProfilePreferences.view.vue?vue&type=template&id=31de1fdc&"
import script from "./ProfilePreferences.view.vue?vue&type=script&lang=js&"
export * from "./ProfilePreferences.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports